// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__3xQir","btnprevnext":"Pagination_btnprevnext__3P1bx","btnpages":"Pagination_btnpages__o0yoG"};